import { normalizeAbsolutePath } from './paths';
import { ConvexError } from 'convex/values';

export type VfsContentNamespace =
  | 'structure'
  | 'system'
  | 'home'
  | 'drive'
  | 'retired';

/** Namespace classification is a constraint, never proof of authorization. */
export function vfsContentNamespace(args: {
  workspaceStorageSlug: string;
  path: string;
  kind: 'file' | 'directory';
}): VfsContentNamespace {
  if (normalizeAbsolutePath(args.path) !== args.path) return 'retired';
  const parts = args.path.split('/').filter(Boolean);
  if (parts[0] === 'global') return 'system';
  if (parts[0] !== args.workspaceStorageSlug) return 'retired';
  if (
    parts.length === 1 ||
    (parts.length === 2 && (parts[1] === 'users' || parts[1] === 'drives'))
  ) {
    return args.kind === 'directory' ? 'structure' : 'retired';
  }
  if (parts.length < (args.kind === 'file' ? 4 : 3)) return 'retired';
  if (parts[1] === 'users') return 'home';
  if (parts[1] === 'drives') return 'drive';
  return 'retired';
}

export function requireVfsContentNamespace(
  args: Parameters<typeof vfsContentNamespace>[0]
): void {
  const namespace = vfsContentNamespace(args);
  if (namespace !== 'home' && namespace !== 'drive') {
    throw new ConvexError('VFS_CONTENT_REQUIRES_HOME_OR_DRIVE');
  }
}
